import { FETCH_USER_LIST } from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const userListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_LIST:
      return { list: action.payload, others: action.others };
    default:
      return state;
  }
};

export default userListReducer;
